// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__nUYZW","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3uhBl"};